import { Filter } from 'bad-words';
import { firestore, collection, query, where, getDocs } from '../lib/firebase';

const filter = new Filter();

export function validateUsername(value: string): string | null {
  if (value.length < 3) {
    return 'Username must be at least 3 characters';
  }
  if (value.length > 20) {
    return 'Username must be less than 20 characters';
  }
  if (!/^[a-zA-Z0-9_]+$/.test(value)) {
    return 'Only letters, numbers, and underscores allowed';
  }
  if (filter.isProfane(value)) {
    return 'Username contains inappropriate language';
  }
  return null;
}

export async function checkUsernameAvailable(username: string, currentUserId?: string): Promise<string | null> {
  try {
    const q = query(
      collection(firestore, 'profiles'),
      where('username', '==', username)
    );
    const snap = await getDocs(q);

    if (!snap.empty) {
      const existingDoc = snap.docs[0];
      if (existingDoc.id !== currentUserId) {
        return 'Username is already taken';
      }
    }
    return null;
  } catch {
    return null; // Don't block on query errors
  }
}
